<section id="our-services" [preRender]="false" (deferLoad)="showBci = true">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 our-services-block-text">
        <div class="services-text">
          <h2>Save Up To 35% Off Flying Private</h2>

          <p>
            Our negotiated contracts with private charter jets and airplanes
            enable us to offer discounts of up to 35%. We thrive on building
            personal long-term relationships with our clients to provide the
            ultimate in white glove customer service and respect. Our primary
            goal is to earn customer loyalty and trust by providing deeply
            discounted fares and incredibly honest and reliable service.
          </p>
        </div>
      </div>
      <div *ngIf="showBci" class="col-md-12 bottom_img">
        <div class="row">
          <picture class="img-fluid-pic">
            <source
              [attr.defaultImage]="cdnPath + '/assets/img/bci/bci.webp'"
              [attr.lazyLoad]="cdnPath + '/assets/img/bci/bci_05.webp'"
              type="image/webp"
            />
            <img
              [defaultImage]="cdnPath + '/assets/img/bci/bci.jpg'"
              [lazyLoad]="cdnPath + '/assets/img/bci/bci_05.jpg'"
              alt="Business Class International"
              class="img-fluid"
            />
          </picture>
          <picture class="img-fluid-pic">
            <source
              [attr.defaultImage]="cdnPath + '/assets/img/bci/bci.webp'"
              [attr.lazyLoad]="cdnPath + '/assets/img/bci/bci_06.webp'"
              type="image/webp"
            />
            <img
              [defaultImage]="cdnPath + '/assets/img/bci/bci.jpg'"
              [lazyLoad]="cdnPath + '/assets/img/bci/bci_06.jpg'"
              alt="Business Class International"
              class="img-fluid"
            />
          </picture>
          <picture class="img-fluid-pic">
            <source
              [attr.defaultImage]="cdnPath + '/assets/img/bci/bci.webp'"
              [attr.lazyLoad]="cdnPath + '/assets/img/bci/bci_07.webp'"
              type="image/webp"
            />
            <img
              [defaultImage]="cdnPath + '/assets/img/bci/bci.jpg'"
              [lazyLoad]="cdnPath + '/assets/img/bci/bci_07.jpg'"
              alt="Business Class International"
              class="img-fluid"
            />
          </picture>
          <picture class="img-fluid-pic">
            <source
              [attr.defaultImage]="cdnPath + '/assets/img/bci/bci.webp'"
              [attr.lazyLoad]="cdnPath + '/assets/img/bci/bci_08.webp'"
              type="image/webp"
            />
            <img
              [defaultImage]="cdnPath + '/assets/img/bci/bci.jpg'"
              [lazyLoad]="cdnPath + '/assets/img/bci/bci_08.jpg'"
              alt="Business Class International"
              class="img-fluid"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>
</section>
